import {
  useParams
} from 'react-router-dom';
import React, {useState,useEffect} from 'react'
import { selectCanAccess } from '../app/auth.js'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { selectUsers, setUsers, usersApi } from '../app/users.js'

// api client
import apiClient from './../app/apiClient.js'
import { projectsApi } from '../app/projects.js';

const OUTPUTFIELDS = {
  projects: `id,name,missions{id,name,inspections{id,name,views{id},layers{type}},potreeLayers{id,name}}`
}

function AccessTrackingPage(props) {
  const dispatch = useDispatch()
  const canAccess = useSelector(selectCanAccess)
  const { projectId } = useParams();
  const [projects, setProjects] = useState(undefined);
  const users = useSelector(selectUsers)
  const [userEvents, setUserEvents] = useState([]);

  useEffect(() => {
    projectsApi.index({id: projectId},OUTPUTFIELDS.projects,({projects}) => {
      setProjects(projects)
    })
    usersApi.index({projectId}, "id,name,email", (users) => {
      dispatch(setUsers({users}))
    })
  },[])

  // Load user events
  useEffect(async () => {
    const result = await apiClient.req("query {access_user_events{userId, category, other_infos, createdAt}}");
    setUserEvents(result.data.data.access_user_events);
  },[])

  // page only for admins
  if (!canAccess('AccessTrackingPage')) {
    return <Navigate to="/" replace />;
  }
  
  // Groupby user and page accessed
  let per_user_and_url = Object.groupBy(userEvents, (ue) => ue.userId + "_" + ue.other_infos?.url);
  // Keep last access
  for (let k of Object.keys(per_user_and_url)){
    per_user_and_url[k].sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)) 
    per_user_and_url[k] = per_user_and_url[k][0];
  }
  // Mission names
  let inspection_mission_names = {};

  if (projects) {
    const missions = projects.flatMap((p) => p.missions)
    for (let mission of missions){
      for (let insp of mission.inspections){
        inspection_mission_names[insp.id] = mission.name
      }
    }
  }
  // User emails
  let user_emails = {};
  if (users != null){
    for (let user of users){
      user_emails[user.id] = user.email;
    }
  }
  // Make table lines
  let rows = [];
  for (let k of Object.keys(per_user_and_url)){
    let ue = per_user_and_url[k];
    let row = {};
    // URL
    if (ue.other_infos == null || ue.other_infos.url == null) continue
    row.url = ue.other_infos.url;
    row.url_pathname = new URL(ue.other_infos.url).pathname;
    if (row.url_pathname !== "/ortho") continue; // Ignore access to other pages than "/ortho" for the moment
    row.mission_name = "N/A";
    const insp_id = new URL(ue.other_infos.url).searchParams.get("inspectionId");
    if (insp_id != null){
      row.mission_name = inspection_mission_names[insp_id];
    }
    // UserId
    let createdAt_as_date = new Date(parseInt(ue.createdAt));
    row.createdAt = createdAt_as_date.toISOString().substring(0, 10) + " " + createdAt_as_date.toTimeString().substring(0, 5);
    row.userId = ue.userId;
    row.email = user_emails[row.userId];
    row.id = rows.length;
    rows.push(row);
  }

  // Sort by date
  rows.sort((a, b) => {
    if (a.createdAt < b.createdAt) return 1;
    else if (a.createdAt > b.createdAt) return -1;
    else return 0;
  })

  return <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
              Last accesses to /ortho pages
            </Typography>
            <Typography component="h4" variant="h7" color="white" gutterBottom>
              (1 row per (inspectionId, userId), sorted by access date, most recent first)
            </Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Mission</TableCell>
                  <TableCell>Page</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.createdAt}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.mission_name}</TableCell>
                    <TableCell><a href={row.url}>{row.url_pathname}</a></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
    </Container>
}

export default AccessTrackingPage
